import {useContext, useMemo} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import GalleryBasic, {COUNTER_POSITIONS, SLIDER_IMAGE_SIZES} from '@adv-mt/mt-gallery-basic'
import {useMediaQuery, useMediaQueryBreakpoints} from '@adv-mt/mt-layout-render-media-query'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

import {NEWS_DETAIL_EXTRA_INFO_BASE_CLASS} from '../config.js'

const IMAGE_GALLERY_BASE_CLASS = `${NEWS_DETAIL_EXTRA_INFO_BASE_CLASS}ImageGallery`

const ImageGallerySection = ({aspectRatio, images, newsTitle}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const initialMediaQueryMatch = {
    defaultMatches: !isMobile
  }

  const isHigherThanMobileResolution = useMediaQuery(useMediaQueryBreakpoints.sm, initialMediaQueryMatch)
  const isHigherThanTabletResolution = useMediaQuery(useMediaQueryBreakpoints.lg, initialMediaQueryMatch)

  const showThumbnails = isHigherThanMobileResolution && images.length > 1

  const imageGalleryImages = useMemo(
    () => images.map(imageSrc => ({src: imageSrc})),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  return (
    <div className={IMAGE_GALLERY_BASE_CLASS}>
      <div className={`${NEWS_DETAIL_EXTRA_INFO_BASE_CLASS}TitleWrapper`}>
        <TitleBasic
          title={i18n.t('NEWS.DETAIL_SECTION_IMAGE_GALLERY', {
            title: newsTitle
          })}
          as={titleBasicTags.h2}
          size={titleBasicSizes.s}
        />
      </div>
      <GalleryBasic
        aspectRatio={aspectRatio}
        counterPosition={COUNTER_POSITIONS.bottomCenter}
        enableCounter
        images={imageGalleryImages}
        showFullSizeBtn={!isHigherThanTabletResolution}
        showThumbnails={showThumbnails}
        sliderImageSize={SLIDER_IMAGE_SIZES.EXTRA_LARGE}
      />
    </div>
  )
}

ImageGallerySection.propTypes = {
  aspectRatio: PropTypes.string,
  images: PropTypes.array,
  newsTitle: PropTypes.string
}

export default ImageGallerySection
